import store from '@/store'
import Util from '@/util'
import * as Sentry from '@sentry/vue'

const updateAudienceData = async () => {
  const payload = {
    audienceId: store.state.audienceId,
    presentationId: store.state.presentation.id,
  }
  if (store.state.audienceEmail) {
    payload.email = store.state.audienceEmail
  }
  if (store.state.audienceName) {
    payload.name = store.state.audienceName
  }
  if (store.state.audienceTeam) {
    payload.organisation = store.state.audienceTeam
  }

  try {
    store.dispatch('createOrUpdateAudienceAction', payload)
    Util.mixpanelTrack(
      'Audience',
      'Audience > Audience Admission > Joined',
    )
  } catch (error) {
    Sentry.captureException(error)
    Util.mixpanelTrack(
      'Audience',
      'Audience > Audience Admission > Failed',
      JSON.stringify(error),
    )
  }
}
export default {
  updateAudienceData,
}
